import{GETRAPPORTS} from "../ActionTypes/RapportTypes"
import axios from "axios"

export const getrapportwell = (params) => async (dispatch) => {
  try {
    const res = await axios.get('/api/Rapports/GetRapports', { params });
    dispatch({
      type: GETRAPPORTS,
      payload: res.data.rapports || []
    });
    return res.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des rapports Wellness:", error);
    dispatch({
      type: GETRAPPORTS,
      payload: []
    });
    return { rapports: [] };
  }
};
    

export const addRapport=(newRapport,navigate)=>async(dispatch)=>{
   try {
       await axios.post('/api/Rapports/AddRapports',newRapport,{
        headers : {
            Authorised : localStorage.getItem('token')
        }
    });

       dispatch(getrapportwell());

        alert("Votre rapport a été bien envoyé à l'administration");
        window.location.reload();
      
   } catch (error) {
       console.error("Erreur lors de l'ajout du rapport:", error);
       alert(error.response?.data?.msg || error.response?.data?.message || "Une erreur est survenue lors de l'envoi du rapport.");
   }
}